import {
  BodyText,
  DialogContent,
  ModalFooter,
  ModalHeader,
  NextDialog,
} from '@cint/wonderment';

interface Props {
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
}

export const NavigateAwayDialog = ({ isOpen, onLeave, onStay }: Props) => {
  return (
    <NextDialog open={isOpen}>
      <DialogContent>
        <ModalHeader
          title="You haven't submitted the file"
          isDismissible={false}
        />
        <BodyText>
          If you leave this page now, the file will be permanently lost and
          cannot be recovered.
        </BodyText>
        <div>
          <BodyText>To keep the file, please:</BodyText>
          <ul className="list-disc ml-4">
            <li>Fix any errors in the file (if there are any)</li>
            <li>Submit it for import</li>
          </ul>
        </div>
        <ModalFooter
          secondaryButtonProps={{
            onClick: onLeave,
            text: 'Leave without saving',
          }}
          primaryButtonProps={{ onClick: onStay, text: 'Stay on page' }}
        />
      </DialogContent>
    </NextDialog>
  );
};
